import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ReviewIdEnum } from '@app/core';
import { RequestService } from '@app/core/request/request.service';
import * as fromRoot from '@app/store/app.reducer';
import { select, Store } from '@ngrx/store';
import { ProductIdEnum } from 'outshared-lib';
import { Observable } from 'rxjs';
import { ProductGradeKeyValue } from './product-grade-key-value.interface';
import * as productGradeActions from './product-grade.actions';
import {
    getProductGradeByProductId,
    getProductGradeByReviewId,
} from './product-grade.selectors';

@Injectable({
    providedIn: 'root',
})
export class ProductGradeService {

    constructor(
        private request: RequestService,
        private store: Store<fromRoot.State>,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {
    }

    /**
     * Request the load of productGrade data
     * Subscribe to getProductGradeByProductId$() to get the grade
     * @param productId - Will be mapped to a ReviewIdEnum
     */
    public loadGradeByProductId(productId: ProductIdEnum): void {
        this.store.dispatch(new productGradeActions.LoadProductGradeByProductId({productId}));
    }

    /**
     * Request the load of productGrade data
     * Subscribe to getProductGradeByReviewId$() to get the grade
     */
    public loadGradeByReviewId(reviewId: ReviewIdEnum): void {
        this.store.dispatch(new productGradeActions.LoadProductGradeByReviewId({reviewId}));
    }

    /**
     * Observable for the requested productGrade from storage
     * @param productId - Will be mapped to a ReviewIdEnum
     */
    public getProductGradeByProductId$(productId: ProductIdEnum): Observable<ProductGradeKeyValue> {
        return this.store.pipe(select(getProductGradeByProductId(productId)));
    }

    /**
     * Observable for  the requested productGrade from storage
     */
    public getProductGradeByReviewId$(reviewId: ReviewIdEnum): Observable<ProductGradeKeyValue>  {
        return this.store.pipe(select(getProductGradeByReviewId(reviewId)));
    }

}
